import type { PostgresRole } from '@/shared/components/ProtectedRoute';
import { ACCOUNT_MANAGER_ROLES } from '@/shared/constants/roles';

/**
 * Who can view the Planète Courrier page (shipments, invoices, aging).
 * Account managers get a view-only page: label creation and package presets
 * are gated separately by the page's ops-only check.
 */
export const PLANETE_COURRIER_PAGE_ROLES: PostgresRole[] = [
  'full_admin',
  'director',
  'operations_manager',
  ...ACCOUNT_MANAGER_ROLES,
];
